/* Universal javascript */

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import swiper from './components/swiper'
import plyr from './components/plyr'
import htmx from './components/htmx'
import ScrollUnveil from './components/scroll-unveil.js'
import BackToTop from './components/back-to-top.js'

window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(() => {
        const elementsToObserve = document.querySelectorAll("[data-su]");

        swiper.init()
        plyr.init()
        htmx.init()

        const sr = new ScrollUnveil({
            threshold: 0.7,
            duration: 400,
        });

        requestAnimationFrame(() => {
            sr.observeElements(elementsToObserve);

            setTimeout(() => {
                sr.triggerVisibleGroups();
            }, 1000);

            new BackToTop({
                threshold: 200,
                hideOnScrollDown: false
            });
        });
    });
})
